import { globalBackendClient } from '@mimir/client-common/globals/backendClient';
import { standardItemEntryKeys } from '@mimir/common/dto/itemModelPrimitives';
import type { StandardItemEntryDto, GetItemsDto } from '@mimir/common/dto/itemModels';
import { api_getItems } from '@mimir/client-common/api/getItemsApi';

export const getItemsWithDefaultFields = async (itemIds: string[]): Promise<StandardItemEntryDto[]> =>
  api_getItems(globalBackendClient, itemIds, standardItemEntryKeys);

export const getItems = async <Key extends keyof (GetItemsDto)>(itemIds: string[], fields: Key[] | readonly Key[]): Promise<Pick<GetItemsDto, Key>[]> =>
  api_getItems(globalBackendClient, itemIds, fields);

